var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ssh-terminal-container"},[_c('div',{ref:"terminal",staticClass:"synpse-xterm"})])}
var staticRenderFns = []

export { render, staticRenderFns }